import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";

import AddMachineMoreInfo from "./AddMachineMoreInfo";

const MachineSummary = ({ machine,userType }) => {
  return (
    <div>
      <Card className="mt-3">
        
        <CardBody>
        {userType !=="unit" ? (<Link to={"machine/" + machine.id} className="navbar-brand pull-right mr-0">
          <Button className="btn-icon btn-3" color="primary" type="button">
            <span className="btn-inner--icon">
              <i className="fa fa-edit"></i>
            </span>
            <span className="btn-inner--text"> Edit</span>
          </Button>
        </Link>): (null)}
        
          <CardTitle>UHA No : {machine.UHANo}</CardTitle>
          <CardSubtitle>Type Identity : {machine.typeIdentity}</CardSubtitle>
          <CardText> Modal : {machine.model}</CardText>
          <CardText> Machine Name : {machine.name}</CardText>
          <CardText> Unit : {machine.unit}</CardText>
        </CardBody>
       
      </Card>

      {userType ==="unit" ? ( <AddMachineMoreInfo />) : (null)}
    </div>
  );
};

export default MachineSummary;
